import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { makeStyles } from "@material-ui/core";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useSettings from "../../../hooks/useSettings";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f9f9f9",
    border: "solid 0.5px #e1e3ee",
    boxShadow: "none",
    margin: "16px 0px 0px !important",
    "& .MuiExpansionPanelSummary-content": {
      margin: "27px 0 27px 24px !important",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: 15,
      backgroundColor: "#fff",
    },
    "& .MuiSvgIcon-root": {
      fill: "#00838c",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function TableWithAccordion({
  MTRef,
  id,
  title,
  ownerType,
  setState,
  type,
  agreementsAndAwards,
}) {
  const classes = useStyles();
  const { setting } = useSettings();

  let templateUrls = [];

  if (type === "mediation" && setting?.mediationTemplateUrl) {
    templateUrls = Array.isArray(setting.mediationTemplateUrl)
      ? setting.mediationTemplateUrl
      : setting.mediationTemplateUrl.split(",").map((s) => s.trim());
  } else if (type === "arbitration" && setting?.arbitrationTemplateUrl) {
    templateUrls = Array.isArray(setting.arbitrationTemplateUrl)
      ? setting.arbitrationTemplateUrl
      : setting.arbitrationTemplateUrl.split(",").map((s) => s.trim());
  }

  // Normalize agreementsAndAwards
  const documents = agreementsAndAwards
    ? Array.isArray(agreementsAndAwards)
      ? agreementsAndAwards
      : agreementsAndAwards.split(",").map((s) => s.trim())
    : templateUrls;

  const hasDocuments = documents.length > 0;

  return (
    <>
      <Accordion className={classes.root}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          // aria-controls="panel1a-content"
          // id="panel1a-header"
        >
          <AccordionHeading>{title}</AccordionHeading>
        </AccordionSummary>
        <div
          style={{
            paddingLeft: "25px",
            paddingBottom: "20px",
            paddingTop: "auto",
            overflow: "auto",
          }}
        >
          {hasDocuments ? (
            <DocumentList>
              {documents.map((url, index) => {
                if (!url) return null;

                const fileName = decodeURIComponent(
                  url.split("/").pop().split("?")[0] || "document",
                );

                return (
                  <DocumentItem
                    key={`${url}-${index}`}
                    onClick={() =>
                      window.open(url, "_blank", "noopener,noreferrer")
                    }
                  >
                    <FileIcon>{"📄"}</FileIcon>
                    <FileName>{fileName}</FileName>
                    <OpenHint>↗</OpenHint>
                  </DocumentItem>
                );
              })}
            </DocumentList>
          ) : (
            <EmptyState>
              <EmptyText>No documents available</EmptyText>
            </EmptyState>
          )}
        </div>
      </Accordion>
    </>
  );
}
export default TableWithAccordion;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 40px;
  margin-top: 15px;
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
`;

export const TableContainer = styled.div`
  /* margin: 30px 29px auto 38px; */
  width: 100%;
  margin-bottom: 15px;
`;

export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #00838c;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
`;

export const AccordionHeading = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
`;

export const AccordionContainer = styled.div`
  padding: 0 20px;
`;

export const ImageWrapper = styled.div`
  cursor: pointer;
`;

export const StyledTitle = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  width: 200px;
`;

const DocumentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  width: 90%;
  transition: all 0.22s ease;

  &:hover {
    background: #f1f5f9;
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.08);
  }
`;

const FileIcon = styled.span`
  font-size: 1.4rem;
  color: #64748b;
  flex-shrink: 0;
`;

const FileName = styled.div`
  flex: 1;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 15px;
  color: #00838c;
  text-decoration: underline;
  word-break: break-all;
  line-height: 1.4;
`;

const OpenHint = styled.span`
  font-size: 1.1rem;
  color: #94a3b8;
  opacity: 0.7;
  transition: all 0.2s;

  ${DocumentItem}:hover & {
    opacity: 1;
    color: #00838c;
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
  text-align: center;
`;

const EmptyText = styled.div`
  font-size: 1rem;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #64748b;
`;
